export default "__VITE_ASSET__mTn0ksBB__"